<template>
    <div>
        <NavigationReceiver currentQuestion="0"></NavigationReceiver>
        <section>
            <div class="custom-container">
                <div class="row d-flex align-items-center">
                    <div class="col-xl-5" v-if="recipient.completed === null">
                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Alle antwoorden worden anoniem opgeslagen. De resultaten kunnen hierdoor nooit aan een persoon worden gekoppeld.</span>
                        </div>
                        <h1 class="mb-5">Je bent uitgenodigd om deze <br>vragenlijst in te vullen</h1>
                        <p>{{ sender.name }} wil je graag 17 korte vragen stellen over de fysieke belasting van je werk (duwen, trekken, tillen, ongemakkelijke werkhoudingen, etc.). Je bent daar
                           ongeveer 15 minuten mee bezig. </p>
                        <p class="mb-5">Jouw antwoorden worden samengevoegd met die van je collega’s, zodat er een goed beeld ontstaat van jouw situatie en wat we samen kunnen verbeteren. Zo proberen
                                        we klachten aan jouw rug, nek, schouders, knieën, etc. te voorkomen.</p>
                        <button class="btn btn-primary mb-3" @click="nextStep($event)">Naar de vragen</button>
                    </div>
                    <div class="col-xl-5" v-if="recipient.completed !== null">
                        <h1 class="mb-5">Bedankt voor het invullen van de vragenlijst!</h1>

                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Alle antwoorden zijn anoniem opgeslagen. De resultaten kunnen hierdoor nooit aan jou worden gekoppeld.</span>
                        </div>
                    </div>
                    <div class="col-xl-6 ms-auto">
                        <div class="bg-secondary p-5 rounded shadow-sm">
                            <div class="row">
                                <div class="col-4">
                                    <ul class="no-bullets mb-0">
                                        <li>Uitgenodigd door</li>
                                        <li>Jouw e-mailadres</li>
                                        <li>Afdeling</li>
                                        <li>Datum uitnodiging</li>
                                        <li>Uiterste inleverdatum</li>
                                    </ul>
                                </div>
                                <div class="col-8">
                                    <ul class="no-bullets mb-0">
                                        <li><span class="bold">{{ sender.name }}</span></li>
                                        <li><span class="bold">{{ recipient.email }}</span></li>
                                        <li><span class="bold">{{ inquiry.department }}</span></li>
                                        <li><span class="bold">{{ formatDate(inquiry.sent) }}</span></li>
                                        <li><span class="bold text-danger">{{ formatDate(inquiry.deadline) }}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RecipientService from "../../../../services/RecipientService";
import {DateTime} from "luxon";

export default {
    name:       'Start',
    components: { NavigationReceiver },
    data() {
        return {
            sender:    {
                name: null
            },
            recipient: {
                email: null
            },
            inquiry:   {
                department: null
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next);
    },
    methods: {
        formatDate(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').toFormat('dd LLL yyyy');
        },
        nextStep(event) {
            event.preventDefault();
            event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

            this.$router.push({ path: '/onderzoek/' + this.recipient.hash + '/stap-1' })
        }
    }
}
</script>
